import { createFragmentContainer, graphql } from 'react-relay';
import EventIndex from './';

export default createFragmentContainer(EventIndex, {
  viewer: graphql`
    fragment EventIndexContainer_viewer on User {
      id
      needs_square_scopes
      ...AvailabilityCheckerContainer_viewer
    }`
});



// WEBPACK FOOTER //
// ./webpack/components/Event/List/EventIndexContainer.js